// removed by extract-text-webpack-plugin
module.exports = {"fileSize":"FileIcon__fileSize___2ghBV","link":"FileIcon__link___2EPUy","fileIcon":"FileIcon__fileIcon___ti0v5","big":"FileIcon__big___1yG_r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FileIcon/FileIcon.scss
// module id = 1173
// module chunks = 1